<template>
  <svg viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="check-hole" maskUnits="userSpaceOnUse">
        <rect width="49" height="49" fill="white" />
        <path
          d="M15.15 25.22l8.57 5.95 11.6-13.7"
          fill="none"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
        />
      </mask>
    </defs>
    <circle
      cx="24.73"
      cy="24.32"
      r="24"
      fill="currentColor"
      mask="url(#check-hole)"
    />
  </svg>
</template>
